import React from "react"
import { useTranslation } from "react-i18next"

import { ProjectsAPIStatus } from "./ProjectsAPIStatus"
import {
  ProjectsOverviewGrid,
  ProjectsOverviewGridProps
} from "./ProjectsOverviewGrid"
import { ProjectsOverviewTableProps } from "./ProjectsOverviewTable"

export interface ProjectsOverviewPageProjectListModel
  extends ProjectsOverviewGridProps,
    ProjectsOverviewTableProps {
  hasFilter?: boolean
  isProjectsServiceAvailable?: boolean
}

export const ProjectsOverviewPageProjectList = React.memo(
  ({
    hasFilter,
    isProjectsServiceAvailable = true,
    ...props
  }: ProjectsOverviewPageProjectListModel) => {
    const { projects, isLoading } = props
    const { t } = useTranslation()

    if (!isProjectsServiceAvailable) {
      return <ProjectsAPIStatus isUnavailable />
    }

    if (!isLoading && projects?.length === 0) {
      return (
        <div className="projects-overview__no-projects-hint">
          {hasFilter
            ? t("Project.NoProjectsWithFilterHint")
            : t("Project.NoProjectsHint")}
        </div>
      )
    }
    return <ProjectsOverviewGrid {...props} />
  }
)
